import React, {Component} from 'react';
import DateHelper from '../components/DateHelper';
import GridView from './GridView';
import StatusIcon from '../components/StatusIcon';
import BiopedModal, { ActionModal } from '../components/BioPedModal';

import User from '../api/User';
import './CalendarView.css';
import Clinic from '../api/Clinic';
import AppointmentView from './Appointments/AppointmentView';
import NewAppForm from './Appointments/forms/NewAppForm';
import moment from 'moment';
import FilterOptions from '../components/FilterOptions';
import TimeGrid from './TimeGrid';
import CalendarWeekView from './CalendarWeekView';
import CalendarDayView from './CalendarDayView';
import ItemToggle from '../components/ItemToggle';
import IconWithCaption from '../components/IconWithCaption';
import {Popup, Icon} from 'semantic-ui-react';
import { ClinicDoctors } from '../components/DataSelectList';
import DateSelectorView from './DateSelectorView';
import InitialsIcon from '../components/InitialsIcon'
import { BioDropDown } from '../components/BiopedUI';
import AppointmentService from '../api/services/AppointmentService';
import AccountService from '../api/services/AccountService';
import ClinicService from '../api/services/ClinicService';
import Doctor, { DoctorSettings } from '../api/Doctor';
import AppointmentTypeService from '../api/services/AppointmentTypeService';
import Preferences from '../api/services/Preferences';
import UserDetails from "./Clients/UserDetails";
import UserForm from "./Clients/forms/UserForm";
import CalendarListView from "./CalendarListView";
import ExtAppService from "../api/services/ExtAppService";
import AppointmentType from "../api/AppointmentType";

const prefs = new Preferences();

let calViewInstance = null;

export default class CalendarView extends Component{
	constructor(props){
		super(props);
		this.state = {modalIsOpen: true, actions:{}, filters:[]};
		//this.handleCalenderItemDrag = this.handleCalenderItemDrag.bind(this);
		this.handleCalendarItemClick = this.handleCalendarItemClick.bind(this);
		//this.handleCalendarItemDrop = this.handleCalendarItemDrop.bind(this);
		this.addNewAppointment = this.addNewAppointment.bind(this);
		this.handleOnNewApp = this.handleOnNewApp.bind(this);
		this.getCalenderItems = this.getCalenderItems.bind(this);

		console.log('----------------- Reconstructing Calendar -----------------------');
	}

	handleFilterChange = (filters) => {
		this.setState({filters:filters});
	}



	applyFilterConditions = (cond, app) => {
		let filters = this.state.filters[cond] || [];

		if(filters.length === 0) return true;
		for (let i = 0; i < filters.length; i++){
			const filter = filters[i];
			const passed = filter(app);
			if(cond === 'and'){
				if (!passed) return false;
			} else {
				if (passed) return true;
			}
		}
		if(cond === 'and') return true;
		return false;
	}


	applyAppFilter = (app) => {

		return this.applyFilterConditions('and', app) && this.applyFilterConditions('or', app);

		const conditions = this.state.filters;
		let hasFilters = false;
		for(let cond in conditions) {
			let filters = conditions[cond];
			for (let i = 0; i < filters.length; i++){
				hasFilters = true;
				const filter = filters[i];
				const passed = filter(app);
				if (cond === 'and' && !passed) return false;
				if (passed) return true;
			}
		}
		if(!hasFilters) return true;
		return false;
	}

	/*applyAppFilter(app){

		let filters = this.state.filters;
		for(let p in filters){

			let group = filters[p];
			if(!this.filterGroup(app, group))return false;
		}
		return true;
	}*/

	getCalenderItems(){
		let items = [];
		let apps = this.props.appData || [];
		return apps.filter(this.applyAppFilter);
	}

	/* getCalenderItemsOld(){
		 let items = [];
		 let apps = this.props.appData || [];



		 for(var i = 0; i < apps.length; i++){

			 let appointment = apps[i];
			 let startPos = this.getPosFromDate(new Date(appointment.start));
			 let endPos = this.getPosFromDate(new Date(appointment.end));
			 let row = startPos[0];
			 let col = startPos[1];
			 let h = endPos[0] - startPos[0];
			 let timeStart = this.getTimeFromRow(row);
			 let timeEnd = this.getTimeFromRow(row + h);
			 let client = new User(appointment.client);
			 items.push(this.getCalenderItem({
				 x:col,
				 y: row,
				 w:1,
				 h:h,
				 maxW:1,
				 minW:1,
				 timeStart: timeStart,
				 timeEnd: timeEnd,
				 app: appointment,
				 name: client.fullName,
			 }))
		 }


		 return items;
	 }*/

	handleCalendarItemClick(item){
		console.log("Calendar Item Clicked!", item)
		if(this.itemIsDragging)return;

		let modalTitle = <div className='table hmax align-top' style={{height:'40px', boxSizing:'border-box', fontSize:'18px', fontWeight:'600', padding:'20px'}}>
			<div>
				<div>Appointment - New</div>
				<div className='align-right' onClick={()=> this.setState({newAppModal: false})}>Cancel</div>
			</div>
		</div>;

		let state = {appModalData:item, modalTitle:modalTitle};
		if(item.appointmentId != null){
			state.appViewModal = true;
		}else{
			state.newAppModal = true;
		}
		//newAppModal

		this.setState(state);
	}

	/*handleCalenderItemDrag(layout , oldItem , newItem , placeholder, e , element){
		//console.log("Item Event:", arguments);
		e.preventDefault();
		let item = CalendarItem.ItemsList[newItem.i];

		let row = this.view.getTimeFromRow(newItem.y);

		//console.log('Row:', newItem.y, '  Time:', row.format('hh:mm a'))

		item.setTimes(row, this.view.getTimeFromRow(newItem.y + newItem.h));
		this.itemIsDragging = true;
	}

	handleCalendarItemDrop(layout , oldItem , newItem , placeholder, e , element){
		setTimeout(() => {
			this.itemIsDragging = false;
		}, 1);
		let item = CalendarItem.ItemsList[newItem.i];
		let startDate = this.view.getDateFromPos(newItem.y, newItem.x);
		let endDate = this.view.getDateFromPos(newItem.y + newItem.h, newItem.x);
		item.updateAppTime(startDate, endDate);

	}

	handleCalenderItemResize(layout , oldItem , newItem , placeholder, e , element){
		console.log("On Calendar Item Resized!", newItem);
	}*/

	addNewAppointment(app){
		console.log("Create Appointment:", app)
		//console.log("Add Item clicked!", "(" + row + "," + col + ")");
		//console.log("Add Date:", this.view.getDateFromPos(row, col));
		//let start = this.view.getDateFromPos(row, col);
		let acc = new AccountService();

		let newApt = {
			clinicId: this.props.clinicId,
			userId: this.props.doctorId
		}

		for(let p in app){
			newApt[p] = app[p];
		}

		this.handleCalendarItemClick(newApt);
	}

	//startTime - endTime from 0 - 23
	get startTime(){
		//Daily Hour
		return this.props.startTime || 8;
	}
	get endTime(){
		//Daily Hour
		return this.props.endTime || 20;
	}

	get timeIncrement(){
		//Minutes
		return this.props.timeIncrement || 15;
	}



	isToday(dt){
		let d = moment();
		let date = moment(dt);
		return d.format('yyyy/mm/dd') == date.format('yyyy/mm/dd');
	}

	handleOnNewApp(app){
		this.setState({appViewModal:false, newAppModal:false});
		if(this.props.onRequestReload){
			this.props.onRequestReload();
		}
	}

	componentDidMount(){
		console.log('Calendar View did Mount!!!!!!!!!!!')
		calViewInstance = this;
		this.__triggerUpdateSectionheader();
	}

	componentWillUnmount() {
		calViewInstance = null;
	}

	__triggerUpdateSectionheader(clinicId, dayViewColItems){
		if(this.props.onSectionHeader){
			console.log('Calendar View Header Actions:', this.props.actions);
			let drSettings = new DoctorSettings();
			let clinic = new Clinic(clinicId || this.props.clinicId);
			let colItems = this.getDrListPref();// Preferences.GetClinicPref('dayViewColItems') || this.state.dayViewColItems || clinic.doctors.getAll();
			this.props.onSectionHeader(<SectionHeader calendarType={this.props.actions.calendarType} dayViewColItems={colItems} onDayViewColItemsChange={this.handleDayViewColChange}  clinicId={clinicId || this.props.clinicId} onAction={this.props.onActionClick} onDateChange={this.props.onDateChange} onDoctorChange={this.props.onDoctorChange} date={this.props.date} />)
		}
	}

	componentDidUpdate(props){
		if(props.clinicId !== this.props.clinicId){
			console.log('Updating');
			//this.state.dayViewColItems = null;
			this.__triggerUpdateSectionheader();
		}
	}

	/*componentWillReceiveProps(props){
		//console.log("Recieving Props!:", props)

	}*/

	getDrListPref() {
		const savedList = Preferences.GetClinicPref('dayViewColItems');
		const dl = ClinicService.GetDoctors(this.props.clinicId, true);
		if (savedList) {

			const allListIndex = {};
			dl.map((dr) => {
				allListIndex[dr.userId] = dr;
			})

			console.log('alluser index:', allListIndex)

			return savedList.map((d) => {
				return allListIndex[d.userId || d];
			})
		}
		return dl;
	}

	handleDayViewColChange = async (items) => {
		//let drSettings = new DoctorSettings();
		//drSettings.setData('dayViewColItems', items);

		await Preferences.SetClinicPref('dayViewColItems', items.map((u) => u.userId));

		this.setState({dayViewColItems:items});
		this.__triggerUpdateSectionheader(null, items);
	}

	showUserDetails = (user) => {
		this.setState({ userDetails: user});
	}

	hideUserDetails = () => {
		this.setState({ userDetails: null});
	}

	showUserDetailEdit = (user) => {
		this.setState({showUserEdit: user, userDetails: null});
	}

	static ShowEditAppointment(app) {
		if(calViewInstance){
			calViewInstance.handleCalendarItemClick(app);
		}
	}

	static CopyAppointment(app){
		if(calViewInstance){
			const copy = Object.assign({}, app);
			delete copy.appointmentId;
			delete copy.seriesGuid;
			
			console.log('Copy App:', copy);
			calViewInstance.handleCalendarItemClick(copy);
		}
	}

	static ShowUserDetails(user) {
		if(calViewInstance){
			calViewInstance.showUserDetails(user);
		}
	}

	static Refresh() {
		if(calViewInstance && calViewInstance.props.onRequestReload){
			calViewInstance.props.onRequestReload();
		}
	}


	render() {
		//let week = this.weekView();
		let today = moment();
		let isThisWeek = moment(this.props.date).week() == today.week();
		let day = (isThisWeek) ? today.day() : 'none';

		let view = null;

		let drSettings = new DoctorSettings();

		let curPed = ClinicService.GetDrById(this.props.doctorId);


		let calStart = Number(this.startTime);//  || 8;
		let calEnd = Number(this.endTime);// | 21;

		console.log("ValendarView Start Time:", calStart, "   Endtime:", calEnd)

		/*if(this.props.onSectionHeader){
			let clinic = new Clinic(this.props.clinicId);
			let colItems = this.state.dayViewColItems || clinic.doctors.getAll();
			this.props.onSectionHeader(<SectionHeader dayViewColItems={colItems} onDayViewColItemsChange={this.handleDayViewColChange}  clinicId={this.props.clinicId} onAction={this.props.onActionClick} onDateChange={this.props.onDateChange} onDoctorChange={this.props.onDoctorChange} date={this.props.date} />)
		}*/

		//this.props.onSectionHeader(<SectionHeader clinicId={this.props.clinicId} onAction={this.props.onActionClick} onDateChange={this.props.onDateChange} onDoctorChange={this.props.onDoctorChange} />)
		switch (this.props.actions.calendarType) {
			case 'day':
				let clinic = new Clinic(this.props.clinicId);

				//console.log('Day View Clinic: ', clinic)

				//const drCols = Preferences.GetClinicPref('dayViewColItems');

				//console.log('** Dr Columns Saved:', drCols);

				let colItems = this.getDrListPref();//drCols ||  this.state.dayViewColItems || ClinicService.GetDoctors(this.props.clinicId, true);// clinic.doctors.getAll();
				//console.log("Doctors:", colItems);

				//view = <DayView ref={(r)=> this.view = r} colItems={colItems} startTime={8} endTime={20} items={this.getCalenderItems()} date={this.props.date} onEmptyCellClick={this.addNewAppointment} onItemResizing={this.handleCalenderItemDrag} onItemDrag={this.handleCalenderItemDrag} onItemDrop={this.handleCalendarItemDrop} onItemResized={this.handleCalendarItemDrop} />;
				view =
					<CalendarDayView colItems={colItems} onColChange={this.handleDayViewColChange} startTime={calStart}
					                 endTime={calEnd} appointments={this.getCalenderItems(true)}
					                 clinicId={this.props.clinicId} doctorId={this.props.doctorId}
					                 date={this.props.date} onCreateAppointment={this.addNewAppointment}
					                 onAppointmentSelect={this.handleCalendarItemClick}
					                 refresh={this.props.onRequestReload}
					                 bcApps={this.props.bcApps}

					/>;
				break;
			case 'list':
				view = <CalendarListView
					startTime={calStart} endTime={calEnd} appointments={this.getCalenderItems()}
					clinicId={this.props.clinicId} doctorId={this.props.doctorId}
					onAppointmentSelect={this.handleCalendarItemClick}
					date={this.props.date}
					refresh={this.props.onRequestReload}
					bcApps={this.props.bcApps}
				/>
				break;
			default:
				//view = <WeekView ref={(r)=> this.view = r} startTime={8} endTime={20} items={this.getCalenderItems()} date={this.props.date} onEmptyCellClick={this.addNewAppointment} onItemResizing={this.handleCalenderItemDrag} onItemDrag={this.handleCalenderItemDrag} onItemDrop={this.handleCalendarItemDrop} onItemResized={this.handleCalendarItemDrop} />;
				view = <CalendarWeekView startTime={calStart} endTime={calEnd} appointments={this.getCalenderItems()}
				                         clinicId={this.props.clinicId} doctorId={this.props.doctorId}
				                         date={this.props.date} onCreateAppointment={this.addNewAppointment}
				                         onAppointmentSelect={this.handleCalendarItemClick}
				                         refresh={this.props.onRequestReload}
				                         bcApps={this.props.bcApps}

				/>;
				break;
		}

		this.__triggerUpdateSectionheader();


		return (
			<div className="calendar-view">
				<CalendarShelf mode={this.props.actions.showLegend}>
					<ShelfLegend clinicId={this.props.clinicId}
					             onRequestClose={() => this.props.onActionClick('showLegend', false)}/>
				</CalendarShelf>
				<CalendarShelf mode={this.props.actions.showFilters}>
					<FilterOptions clinicId={this.props.clinicId}
					               onRequestClose={() => this.props.onActionClick('showFilters', false)}
					               onChange={this.handleFilterChange}/>
				</CalendarShelf>
				{view}

				<ActionModal className='app-view-modal' close='Cancel' isOpen={this.state.newAppModal}
				             onRequestClose={() => this.setState({newAppModal: false})} title={'Appointment - New'}>
					<NewAppForm appointment={this.state.appModalData} onSave={this.handleOnNewApp}
					            clinicId={this.props.clinicId} doctorId={this.props.doctorId}/>
				</ActionModal>
				{/*<AppointmentView appointment={this.state.appModalData} onSave={this.handleOnNewApp} clinicId={this.props.clinicId} doctorId={this.props.doctorId}  isOpen={this.state.appViewModal} onRequestClose={() => this.setState({appViewModal:false}) } />*/}
				<ActionModal title="Appointment - Edit" close='Cancel' isOpen={this.state.appViewModal}
				             onRequestClose={() => this.setState({appViewModal: false})}>
					<NewAppForm appointment={this.state.appModalData} clinicId={this.props.clinicId}
					            doctorId={this.props.doctorId} onSave={this.handleOnNewApp}/>
				</ActionModal>

				<BiopedModal isOpen={this.state.userDetails} onRequestClose={this.hideUserDetails}>
					<UserDetails hideEdit={this.props.hideEdit} user={this.state.userDetails} backCaption='Close'
					             onBack={this.hideUserDetails} onEdit={this.showUserDetailEdit}/>
				</BiopedModal>

				<ActionModal close='Close' title='Edit Patient' className='scrollable' isOpen={this.state.showUserEdit}
				             onRequestClose={() => this.setState({showUserEdit: false})}>
					<UserForm className='popup-form' user={this.state.showUserEdit}
					          onBack={() => this.setState({showUserEdit: false})}/>
				</ActionModal>

			</div>

		)
	}
}



export class CalendarItem extends Component{
	static colors = [
		'#F9A14A',
		'#5D4DA1',
		'#C1198B',
		'#42A444'
	];

	static ItemIds = 0;
	static ItemsList = {};
	constructor(props){
		super(props);

		let status = ['good', 'bad', 'none'];
		let icon = ['call', 'text', 'email'];

		this.clinic = new Clinic(props.appointment.clinicId);
		this.appType = this.clinic.getAppType(this.props.appointment.appointmentTypeId);

		//console.log("App Type:", this.appType);

		this.state = {
			color:'#' + this.appType.color,// CalendarItem.colors[parseInt(Math.random() * CalendarItem.colors.length)],
			timeStart: this.props.timeStart,
			timeEnd: this.props.timeEnd,
			status: this.props.appointment.status,// status[parseInt(Math.random() * status.length, 10)],
			icon: icon[parseInt(Math.random() * icon.length, 10)]
		}

		this.handleModalClose = this.handleModalClose.bind(this);
		this.handleSelect = this.handleSelect.bind(this);


	}

	componentDidMount(){
		CalendarItem.ItemsList[this.props.id] = this;
	}

	componentWillUnmount(){
		delete CalendarItem.ItemsList[this.props.id];
	}

	formatTime(time){

		let format =  'h:mm a';
		if(time.minute() == 0){
			format = 'h a';
		}

		return time.format(format);

		/*let t = moment(time);
		let hour = t.hour();
		let min = t.minute();
		let ampm = hour < 12? 'am' : 'pm';
		let hourDisp = hour > 12? hour - 12: hour;
		if(min){
			min = min < 10? 0 + '' + min : min;
			return hourDisp + ':' + min + ' ' + ampm;
		}

		return hourDisp + ' ' + ampm;*/
	}

	updateAppTime(start, end){
		if(this.state.isBusy)return;
		/*let st = moment(this.props.appointment.start);
		let en = moment(this.props.appointment.start);

		st.hour(start.hour).minutes(start.min);
		en.hour(end.hour).minutes(end.min)

		let updateApp = {
			appointmentId: this.props.appointment.appointmentId,
			start: start.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
			end: end.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),

		}

		console.log("Update AppTime:", updateApp)
		*/

		let oldStart = moment(this.props.appointment.start).format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
		let oldEnd = moment(this.props.appointment.end).format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
		let newStart = start.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
		let newEnd = end.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);

		if(oldStart == newStart && oldEnd == newEnd){
			return;
		}

		this.props.appointment.start = newStart;// start.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
		this.props.appointment.end = newEnd;// end.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)

		let appserv = new AppointmentService();
		appserv.createApp(this.props.appointment).then((d) => {
			console.log("Appointment Updated:", d);
			this.setState({isBusy:false})
		})

		this.setState({isBusy:true});
	}

	setTimes(start, end){
		this.setState({timeStart:start, timeEnd:end});
	}

	handleStatusClick(e){
		let app = new AppointmentService();
		app.getAppointments('2018-01-20T04:57:46.2782183+00:00', '2018-01-28T04:57:46.2782183+00:00', (d) => {
			console.log("appointments:", d)
		})
		this.setState({modalOpen: true});
	}

	handleModalClose(){
		this.setState({modalOpen: false});
	}

	handleSelect(){
		if(this.props.onSelect){
			this.props.onSelect(this.props.appointment);
		}
	}

	render(){
		let time = this.formatTime(this.state.timeStart) + " - " + this.formatTime(this.state.timeEnd);
		let style = {
			backgroundColor: this.state.color
		}

		return(
			<div className="calendar-item" style={style} onClick={this.handleSelect}>
				<div className="name">{this.props.name}</div>
				<div className="time">{time}</div>
				<StatusIcon icon={this.state.icon} status={this.state.status} />
			</div>

		)
	}
}

export class CalendarShelf extends Component{
	render(){
		return(
			<div className='calendar-shelf' mode={this.props.mode ? 'open':'closed'}>{this.props.children}</div>
		)
	}
}

export class ShelfLegend extends Component{
	state = {};
	componentDidMount(){
		let clinic = new Clinic(this.props.clinicId);
		let apps = AppointmentTypeService.GetAppTypes(this.props.clinicId);// clinic.appTypes.getAll();
		let items = [];
		//items.push(<div className='close-btn' onClick={this.props.onRequestClose}>HIDE</div>);
		console.log('Shelf Legend App Types:', apps)
		for(let i=0; i < apps.length; i++){
			let item = new AppointmentType(apps[i]);
			items.push(<div key={item.appointmentTypeId} className='legend-item'><span className="color" style={{backgroundColor:"#" + item.color}}></span><span className='name'>{item.name}</span></div>)
		}

		this.setState({items:items});
	}

	render(){
		return(
			<div className='shelf-legend'>{this.state.items}</div>
		)
	}
}


class SectionHeader extends Component{
	state = {
		calendarType:'week'
	};
	constructor(props) {
		super(props);

		this.handleActionClick = this.handleActionClick.bind(this);

	}

	/*componentDidMount(){
		console.log("Section header did Mount:", this.props.calendarType)
		this.setState({calendarType:this.props.calendarType || 'week'})

	}*/

	handleActionClick(action, value){
		let o = {};
		o[action] = value;
		this.setState(o);
		if(this.props.onAction){
			this.props.onAction(action, value)
		}
	}

	toggleLegend = ()=>{
		let state = !this.state.showLegend;
		this.setState({showLegend:state});
		this.handleActionClick('showLegend', state);

	}

	render(){


		return(
			<div className='calendar-section-header table align-middle hmax' display-mode={this.props.calendarType}>
				<div>
					<div className='week-view-only'><ClinicDoctors onChange={this.props.onDoctorChange} value={this.props.currentDoctor}  clinicId={this.props.clinicId}  /></div>
					<div className='day-view-only'>
						<DrColumnList clinicId={this.props.clinicId} list={this.props.dayViewColItems} onChange={this.props.onDayViewColItemsChange} />
					</div>
					<div className="hmax align-center">
						<DateSelectorView onChange={this.props.onDateChange} mode={this.props.calendarType == 'day' ? 'single':'week'} date={this.props.date} />
					</div>

					<div>
						<div className='table controls'>
							<div>
								<div >

									<ItemToggle className='day-week-toggle' value={this.props.calendarType} onChange={(v) => this.handleActionClick('calendarType', v) } items={
										{
											week:<IconWithCaption icon='calendarWeek' caption='week' />,
											day:<IconWithCaption icon='calendarDay' caption='day' />,
											list:<IconWithCaption icon='list' caption='list' />
										}
									} />
								</div>
								<div><IconWithCaption icon='filter' caption='filter' className='header-filter-btn' onClick={()=> this.handleActionClick('showFilters', !this.state.showFilters)} /></div>
								<div>
									<Popup trigger={<IconWithCaption icon='more' caption='more' className='header-more-btn' />} on='click' hideOnScroll hoverable flowing position="bottom right">
										<div className='header-more-options'>
											<div className={(this.state.showLegend)? 'active':null} onClick={this.toggleLegend}>Show Colour Legend</div>
											<div onClick={()=> this.handleActionClick('noShowVisible', true)}>View Cancellations / No Shows</div>
											<div onClick={()=> this.handleActionClick('printAppsVisible', true)}>Print Appointments</div>
											{/*<div onClick={()=> this.handleActionClick('toggleTimeMode', !this.state.toggleTimeMode)}>Change to {this.state.toggleTimeMode? 12:24} Hour Time</div>
                                            <div onClick={()=> this.handleActionClick('clinicHoursVisible', true)}>View Clinic Hours</div>*/}
										</div>
									</Popup>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

class DrColumnList extends Component{
	state = {};
	clinic = {};
	doctors = [];

	componentWillMount(){
		this.updateDrList();
	}

	componentWillReceiveProps(newProps){
		if(newProps.clinicId != this.props.clinicId){
			this.updateDrList(newProps.clinicId);
		}
		this.syncDrList(newProps.list);
	}

	updateDrList(clinicId){
		this.clinic = new Clinic(clinicId || this.props.clinicId);
		let drs = this.clinic.doctors.getAll();
		//console.log("Doctors GetAll:", drs)
		this.doctors = [];
		for(let i=0; i < drs.length; i++){
			let user = new User(drs[i]);
			user._enabled = true;
			this.doctors.push(user);
		}
	}

	syncDrList(userList){
		let curList = this.getListByIds(userList);
		let doctors = this.doctors;
		for(let i=0; i < doctors.length; i++){
			let dr = doctors[i];
			dr._enabled = !!curList[dr.userId];
		}
	}


	getList(){
		let list = [];
		//console.log("Dr Column List: ", this.props.list)
		for(let i=0; i < this.doctors.length ; i++){
			let dr = this.doctors[i];
			if(!dr._enabled)list.push(<InitialsIcon key={'initalsIcon_' + dr.userId} name={dr.fullName} onClick={()=> this.handleUserToggle(dr)} />);
		}
		return list;
	}

	handleAdd = () => {
		this.setState({showAddModal:true})
	}

	handleCloseAdd = () =>{
		this.setState({showAddModal:false})
	}

	getListByIds(userList){
		let list = userList || this.props.list
		let ids = {};

		for(let i=0; i < list.length; i++){
			let user = list[i] || {};
			if(user.userId != null)ids[user.userId] = user;
		}
		return ids;
	}

	getDoctorById(id){
		for(let i=0; i < this.doctors.length; i++){
			let dr = this.doctors[i];
			if(dr.userId == id)return dr;
		}
	}

	handleUserToggle = (user) => {
		let dr = this.getDoctorById(user.userId);
		let list = [];
		dr._enabled = !dr._enabled;
		for(let i=0; i < this.doctors.length; i++){
			let dr = this.doctors[i];
			if(dr._enabled)list.push(dr);
		}

		if(this.props.onChange){
			this.props.onChange(list);
		}
	}

	genDrList(){
		let list = [];
		let drs = this.doctors;
		let curList = this.getListByIds();
		//console.log('curList:', curList);
		for(let i=0; i < drs.length; i++){
			const dr = drs[i];
			list.push(<DrListItem key={dr.userId} user={dr} enabled={dr._enabled} onToggle={this.handleUserToggle} />);
		}
		return list;
	}

	render(){
		return(
			<div className='dr-column-list table align-middle align-center layout-fixed'>
				<div>
					{this.getList()}
					<div>
						<div className='add-btn' onClick={this.handleAdd}>+</div>
					</div>
				</div>
				<ActionModal title="Add Pedorthist" close='Close' className='dr-list-modal' isOpen={this.state.showAddModal} onRequestClose={this.handleCloseAdd}>
					{this.genDrList()}
				</ActionModal>
			</div>
		)
	}
}



class DrListItem extends Component{
	toggle = () => {
		if(this.props.onToggle){
			this.props.onToggle(this.props.user);
		}
	}
	render(){
		let user = this.props.user;
		let addrem = this.props.enabled ? 'Remove':'Add';
		return (
			<div className={'dr-list-item table hmax align-middle' + (this.props.enabled? ' enabled':' disabled') }>
				<div>
					<div className='initials'><div>{user.initials}</div></div>
					<div className='user-name'>{user.fullName}</div>
					<div><span onClick={this.toggle} className='action'>{addrem}</span></div>
					<div className='drag-handle'>=</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/CalendarView.js